import {DeviceDetectorService} from "ngx-device-detector";

export abstract class DeviceDetectionComponent {
    isMobile: boolean;

    protected constructor(public deviceService: DeviceDetectorService) {
        this.isMobile = deviceService.isMobile();
    }
}
